import { SuperscaleMark } from '@/features/landing-page/v3/superscale-mark'
import { LpBillingPlans } from '@/features/landing-page/v3/sections/lp-billing-plans'
import { LpFaqSectionV3 } from '@/features/landing-page/v3/sections/lp-faq-section-v3'
import { LP_GRID } from '@/features/landing-page/v3/lp-grid'

/**
 * lp-v3 /pricing page body — rendered by the landing shell instead of the home sections when the new
 * design is active on /pricing (the default per-route hero is suppressed there; this owns its hero).
 * The chrome around it (nav, above-footer fanned cards, footer) comes from the shell like on every
 * other v3 page. The plans are the REAL BillingPlans (tabs, live data, full CTA logic) in the
 * redesign skin — see LpBillingPlans.
 */
export function LpPricingSections() {
    return (
        // Pricing-only background: #F0EEEA warms the whole page vs the cream default. Pulled up
        // under the fixed nav so the grey reaches the viewport top (nav sits fixed with its own
        // gradient; without this pull-up the 64px reserved by main's marginTop stays cream).
        <div className="bg-[#F0EEEA] -mt-[64px] pt-[64px]">
            {/* Hero — clover + the one pricing heading; second line in the pixel font, orange. */}
            <div className={`${LP_GRID.contentSection} flex flex-col items-center pb-10 pt-10 text-center md:pb-14 md:pt-14`}>
                <SuperscaleMark className="size-10 text-[#FF5500] md:size-12" />
                <h1 className="mt-6 text-[32px]! font-medium leading-[1.1]! tracking-[-0.01em]! text-[#131210] md:text-[40px]!">
                    <span className="block">Your Agents. Performing Ads.</span>
                    <span className="block font-[family-name:var(--font-landing-pixel)]! text-[#FF5500]!">
                        A system that scales with you
                    </span>
                </h1>
            </div>

            {/* Plan cards — real billing plans in the v3 skin (no Individual/Professional switcher). */}
            <section className={LP_GRID.contentSection}>
                <div className="mx-auto w-full max-w-[1320px]">
                    <LpBillingPlans />
                </div>
            </section>

            {/* FAQ */}
            <LpFaqSectionV3 />
        </div>
    )
}
